import { Badge } from '../badge';
import { cn } from '../../lib/utils';

interface CountBadgeProps {
  value: number;
  className?: string;
}

export function CountBadge({ value, className }: CountBadgeProps) {
  return (
    <Badge variant="secondary" className={cn('text-xs', className)}>
      {value}
    </Badge>
  );
}
